import { debug } from 'src/logger';

const MAX_RETRIES = 2;

export const retryFetch = async <T>(
    fetchFn: () => Promise<T>,
    retries: number = MAX_RETRIES
): Promise<T> => {
    try {
        return await fetchFn();
    } catch (error) {
        if (retries > 0) {
            debug(`Retrying... ${retries} attempts remaining`);
            return retryFetch(fetchFn, retries - 1);
        }
        throw error;
    }
};
